import defaultNabooPanel from '@/presentation/plugins/presets/components/panel/defaultNabooPanel.ts'

const nabooPanel = {
  colorScheme: {
    light: defaultNabooPanel
  }
}

export default nabooPanel
